<script setup>
import { Link } from '@inertiajs/vue3';
import { PlusIcon } from '@heroicons/vue/24/solid';

const props = defineProps({
    actionButtons: {
        type: Array,
        required: true
    }
});
</script>

<template>
    <div v-if="actionButtons.length" class="max-w-fit flex flex-col space-y-2">
        <Link
            v-for="actionButton in actionButtons"
            cy-test="action-button"
            :key="actionButton.url"
            :href="actionButton.url"
            class="w-14 h-14 rounded-full shadow-md bg-linear-to-bl from-theme-circlegradientfrom to-theme-circlegradientto flex flex-col justify-center items-center text-white focus:pink-400"
        >
            <PlusIcon class="w-6 h-6" />
        </Link>
    </div>
</template>
